module.exports = __webpack_public_path__ + "img/高集成.5c3a6ca7.png";